var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"icon hero-icon hero-icon-add"},[_vm._v(_vm._s(_vm.$t("UE.ue_traffic")))]),_c('UeChart',{ref:"ueChart"})],1),_c('div',[_c('span',{staticClass:"icon hero-icon hero-icon-add"},[_vm._v(_vm._s(_vm.$t("UE.ue_camera")))]),_c('UeCameraTable',{ref:"ueCameraTable"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }